import AppWrapper from "../../../components/cm/AppWrapper";
import ReportDetail from "../../../components/cm/Dashboard/FullPages/Reports/components/ReportsDetail";
import { MainNavBarEnum } from "../../../components/cm/SideBarMain/MainNavBarEnum";
import SideBarMain from "../../../components/cm/SideBarMain/SideBar";

export default () => {
  return (
    <AppWrapper.WithSidebar sidebar={<SideBarMain activeRoute={MainNavBarEnum.REPORTS} />}>
      <ReportDetail />
    </AppWrapper.WithSidebar>
  );
};
